import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisFit = _resolveComponent("EllipsisFit")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["widget-kpi", {snapshot: $props.snapshot}])
  }, [
    _createVNode(_component_EllipsisFit, {
      ref: "value",
      class: "value",
      text: $props.widget.value
    }, null, 8 /* PROPS */, ["text"]),
    ($options.show_direction)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          class: "direction",
          icon: $props.widget.direction === 'up' ? 'trend-up-01' : 'trend-down-01',
          stroke: $props.widget.direction === 'up' ? 'var(--success-600)' : 'var(--error-600)',
          "stroke-width": "2",
          size: "2.4rem"
        }, null, 8 /* PROPS */, ["icon", "stroke"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}